import React from 'react'
import TaskItem from './TaskItem'

const TaskList = ({ tasks, onToggleComplete, onDeleteTask, onUpdateTaskDate }) => {
  return (
    <ul className='task-list'>
      {tasks.map(task => (
        <TaskItem key={task.id} task={task} onToggleComplete={onToggleComplete} onDeleteTask={onDeleteTask} onUpdateTaskDate={onUpdateTaskDate} />
      ))}
    </ul>
  )
}

export default TaskList
